namespace SP {

    export async function promise<T>(data : T) : Promise<T> {
        return new Promise<T>((resolve) => {
            resolve(data);
        });
    }
}